import script from "./contactService.vue?vue&type=script&setup=true&lang=ts"
export * from "./contactService.vue?vue&type=script&setup=true&lang=ts"

import "./contactService.vue?vue&type=style&index=0&id=33363016&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33363016"]])

export default __exports__